import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';

const LogoXsmall = (): React.JSX.Element => {
	return <AtlassianIcon size="xsmall" appearance="brand" />;
};

export default LogoXsmall;
